'use client';

import { notifications } from '@mantine/notifications';

interface ToastOptions {
  title: string;
  description?: string;
}

// Export a function to show a toast notification
export const toaster = {
  // Success notification
  success: ({ title, description }: ToastOptions) => {
    notifications.show({
      title,
      message: description,
      color: 'green',
    });
  },

  // Error notification
  error: ({ title, description }: ToastOptions) => {
    notifications.show({
      title,
      message: description,
      color: 'red',
    });
  },

  // Info notification
  info: (props: { title?: string; description?: string }) => {
    return notifications.show({
      title: props.title,
      message: props.description,
      color: 'blue',
    });
  },

  // Loading notification that you can update later
  loading: (props: { title?: string; description?: string }) => {
    const id = notifications.show({
      title: props.title,
      message: props.description,
      loading: true,
      autoClose: false,
      withCloseButton: false,
    });

    return id;
  },

  // Update a loading notification
  update: (id: string, props: { title?: string; description?: string; type?: 'success' | 'error' | 'info' }) => {
    notifications.update({
      id,
      title: props.title,
      message: props.description,
      color: props.type === 'success' ? 'green' : props.type === 'error' ? 'red' : 'blue',
      loading: false,
      autoClose: 2000,
    });
  },

  // Dismiss a notification
  dismiss: (id: string) => {
    notifications.hide(id);
  },
};
